<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h4 class="green--text headline mb-0">Solicitudes</h4>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
        :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="items"
          class="elevation-1"
          light
          :loading="tableLoading"
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.date }}</td>
            <td class="text-xs-left">{{ props.item.applicantTeam }}</td>
            <td class="text-xs-left">{{ props.item.requestType }}</td>
            <td class="text-xs-left">{{ props.item.tournament }}</td>
            <td class="text-xs-left">
                <v-btn
                    color="green"
                    slot="activator">Ver
                </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    export default {
        name: "Requests",
        data: () => ({
            tableLoading: false,
            headers: [
            { text: 'Fecha', value: 'date', align: 'left' },
            { text: 'Equipo Solicitante', value: 'applicantTeam', align: 'left' },
            { text: 'Tipo de Solicitud', value: 'requestType', align: 'left' },
            { text: 'Torneo', value: 'tournament', align: 'left' },
            { text: '', value: 'delete', align: 'left' }
            ],
            items: [
            {
                date: new Date().toString(),
                applicantTeam: 'Amplemind',
                requestType: 1,
                tournament: 'Metrogol'
            },
            {
                date: new Date().toString(),
                applicantTeam: 'PITZ',
                requestType: 1,
                tournament: 'Metrogol'
            }
            ]
        })
    }
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/requests/requests.vue